import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Start } from './screens/Start';
import { StorySelection } from './screens/StorySelection';
import { PlushUpload } from './screens/PlushUpload';
import { PersonalDetails } from './screens/PersonalDetails';
import { Loading } from './screens/Loading';
import { Preview } from './screens/Preview';
import { Review } from './screens/Review';
import { IPError } from './screens/IPError';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Start />} />
        <Route path="/story" element={<StorySelection />} />
        <Route path="/plush" element={<PlushUpload />} />
        <Route path="/personal" element={<PersonalDetails />} />
        <Route path="/loading" element={<Loading />} />
        <Route path="/preview" element={<Preview />} />
        <Route path="/buch/:publicId/review" element={<Review />} />
        <Route path="/ip-error" element={<IPError />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
